import { Component, OnDestroy, OnInit, forwardRef, DoCheck } from '@angular/core';
import { ControlContainer, NgForm } from '@angular/forms';
import { ICardComponentInjectionToken } from '../../../_infrastructure/ValidationMessages/ExternalValidationDirective';
import { WorkflowComponentNew } from '../../workflow-new.component';
import { PrestacoesMorteValueObservableService} from '../../../_infrastructure/Documents/PrestacoesPorMorteValueObserver';
@Component({
  selector: 'sender-qualification',
  templateUrl: './sender-qualification.component.html',
providers: [
    {
    provide: ICardComponentInjectionToken,
    useExisting: forwardRef(() => SenderQualificationComponent)
    }],
  viewProviders: [{ provide: ControlContainer, useExisting: NgForm }],
  standalone: false
})

export class SenderQualificationComponent implements OnInit, OnDestroy {


  // Declaramos o cardData como get + set em vez de variável simples pois precisamos abaixo de agarrar lógica ao momento
  //  de atualização do cardData ( evita o ngDoCheck ou ngOnChanges ou afins )
  public get cardData(): models.SenderQualificationVM {
    return this._cardData;
  }
  public set cardData(value: models.SenderQualificationVM) {
    this._cardData = value;
    this.onCardDataChanged(); // Este é o método chamado quando temos mudança no cardData ( atualizado pelo step ), abaixo temos a implementação e a lógica
  }
  private _cardData: models.SenderQualificationVM = {} as models.SenderQualificationVM;

  public parentWorkflow: WorkflowComponentNew;


  constructor(private prestacoesPorMorteValueObserver: PrestacoesMorteValueObservableService) {
  }

  ngOnInit(): void {
  }

  ngOnDestroy(): void {
    
  }


  private onCardDataChanged() {

    this.cardData.isBeneficiary = this.parentWorkflow.workflowInstance.StepSender?.SenderQualification?.isBeneficiary?.toString() == "true" ? true : false;
    this.cardData.isLegalRepresentative = this.parentWorkflow.workflowInstance.StepSender?.SenderQualification?.isLegalRepresentative?.toString() == "true" ? true : false;

    //const isLegalRepresentativeValidation = this.prestacoesPorMorteValueObserver
    //  .legalRepresentativeValidation(this.cardData.isLegalRepresentative);

    //this.prestacoesPorMorteValueObserver.changeLegalRepresentativeNotification(
    //  this.parentWorkflow.workflowInstance.StepSender?.SenderIdentification?.name,
    //  this.parentWorkflow.workflowInstance.StepSender?.SenderIdentification?.NIF,
    //  isLegalRepresentativeValidation);      

  }

  public isBeneficiaryChanged(value: boolean) {
    this.cardData.isBeneficiary = value ;
  }

  public isLegalRepresentativeChanged(value: boolean) {
    this.cardData.isLegalRepresentative = value;
    //const isLegalRepresentativeValidation = this.prestacoesPorMorteValueObserver
    //  .legalRepresentativeValidation(this.cardData.isLegalRepresentative);
    //this.prestacoesPorMorteValueObserver.changeLegalRepresentativeNotification(
    //  this.parentWorkflow.workflowInstance.StepSender?.SenderIdentification?.name,
    //  this.parentWorkflow.workflowInstance.StepSender?.SenderIdentification?.NIF,
    //  isLegalRepresentativeValidation);      
  }

}
